import Vue from 'vue';
import App from './App.vue';
import InstantSearch from 'vue-instantsearch';
import VueGoogleMaps from 'vue-googlemaps';

Vue.config.productionTip = false;

Vue.use(InstantSearch);

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyBFArOWq_HXesi3Gn4X-VZiCZjAKjiDgWo',
  },
});

new Vue({
  render: h => h(App),
}).$mount('#app');
